
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.4 19.3L41 12.9V6h-6v2.3L25 .7.6 19.3l1.5 2L4 19.8V47h14.9V27h12.2v20H46V19.8l1.9 1.5z"}})])
          )
        }
      }
    